module.exports = __webpack_public_path__ + "static/modernizace-php-aplikaci-1-9746177f3d63845e9942699246655636.jpg";